import { FETCH_SMILE_DESIGNS_START, FETCH_SMILE_DESIGNS_SUCCESS, FETCH_SMILE_DESIGNS_ERROR } from '../../actions/smile_designs/smile_designs';

const initialState = {
  caseId: null,
  list: [],
  loading: false,
  error: null,
};

export function smileDesignsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_SMILE_DESIGNS_START:
      return { ...state, loading: true, error: null };
    case FETCH_SMILE_DESIGNS_SUCCESS:
      return { ...state, loading: false, caseId: action.caseId, list: action.list };
    case FETCH_SMILE_DESIGNS_ERROR:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
}

export const getSmileDesigns = (state) => state.smileDesignsReducer;
export const getSmileDesignsList = (state) => state.smileDesignsReducer.list;
